import React, { useCallback } from 'react';
import { PopoverHeader, FormControl, FormLabel, Flex, Select, IconButton, PopoverCloseButton } from '@chakra-ui/react';
import { allPages, updatePages, updateComponent } from '../../../redux/pagesSlice';
import { selectedPage } from '../../../redux/selectedPageSlice';
import { useSelector, useDispatch } from 'react-redux';
import { UilTrashAlt } from '@iconscout/react-unicons';
import { findCompByIdRecursively, fixIndexes } from '../../../utils/functions';
import { selectedComponent, selectComponent } from '../../../redux/selectedComponentSlice';
import components from '../../../utils/componentsDictionary';
import _ from 'lodash';
import MenuResetComponent from './MenuResetComponent';
import DuplicateComponent from './DuplicateComponent';

const r300 = { bg: 'red.300', borderColor: 'red.300' };
const r400 = { bg: 'red.400', borderColor: 'red.400' };

function removeElement({ componentId, pages, dispatch, selectedPageValue, selectedComponentPropsValue }) {
	const newPages = JSON.parse(JSON.stringify(pages));
	const pageIndex = newPages.findIndex((page) => page.pageId == selectedPageValue);
	const page = newPages[pageIndex];
	const { parentArray } = findCompByIdRecursively(page.pageData, componentId);
	const foundIndex = parentArray.findIndex((comp) => comp.componentId == componentId);
	const moveTo = parentArray[foundIndex]?.moveTo;
	parentArray.splice(foundIndex, 1);
	if (moveTo) {
		fixIndexes(page, foundIndex, moveTo);
	}
	dispatch(updatePages(newPages));
	//
	if (selectedComponentPropsValue.componentId == componentId) {
		dispatch(selectComponent(null));
	}
}

function moveElement(e, editorRef, offset) {
	const px = e.pageX;
	const py = e.pageY;
	editorRef.current.style.top = py - offset.y + 'px';
	editorRef.current.style.left = px - offset.x + 'px';
}

function handleMouseMove(e, isDragging, offset, editorRef) {
	e.stopPropagation();
	e.preventDefault();
	if (!isDragging) return;
	moveElement(e, editorRef, offset);
}
function handleMouseDown(setOffset, setIsDragging, e, editorRef) {
	if (e.target.nodeName == 'SELECT') return;
	setIsDragging(true);
	const px = e.pageX;
	const py = e.pageY;
	const ex = editorRef?.current?.offsetLeft || 0;
	const ey = editorRef?.current?.offsetTop || 0;
	const xOffset = px - ex;
	const yOffset = py - ey;
	setOffset({ x: xOffset, y: yOffset });
}

function getTemplateOptions(templates) {
	return templates.map((template, index) => {
		return (
			<option key={'template-selector-' + index} value={template}>
				{template}
			</option>
		);
	});
}

function setSelectedTemplate(selectedTemplate, dispatch, componentId, selectedPageValue, componentGroup, xPos, yPos) {
	const getCompConfig = components.find((e) => e.componentName === componentGroup);
	console.log(getCompConfig.componentProps);
	const newProps = getCompConfig.componentProps(selectedTemplate);
	newProps.templateId = selectedTemplate;
	dispatch(
		updateComponent({
			component: newProps,
			componentId,
			pageId: selectedPageValue,
		}),
	);
	dispatch(selectComponent({ props: newProps, xPos, yPos, childComp: null }));
}

const EditorInputsHeaderWM = ({ editorRef, setIsDragging, isDragging }) => {
	const debounceDrag = useCallback(_.throttle(handleMouseMove, 0), [isDragging]);
	const { props: selectedComponentPropsValue, xPos, yPos } = useSelector(selectedComponent);
	const { templateId, componentId, componentGroup } = selectedComponentPropsValue;
	const pages = useSelector(allPages);
	const selectedPageValue = useSelector(selectedPage);
	const dispatch = useDispatch();
	const [offset, setOffset] = React.useState({ x: 0, y: 0 });
	const [templates, setTemplates] = React.useState([1]);

	React.useEffect(() => {
		const comp = components.find((e) => e.componentName === componentGroup);
		if (comp?.templates) {
			setTemplates(Object.keys(comp.templates));
		}
	}, [componentGroup]);
	return (
		<PopoverHeader
			borderRadius={'6px'}
			d={'flex'}
			flexDir={'vertical'}
			_hover={{ cursor: 'grab' }}
			bg={'gray.100'}
			onMouseDown={(e) => handleMouseDown(setOffset, setIsDragging, e, editorRef)}
			onMouseUp={(e) => setIsDragging(false)}
			onMouseMove={(e) => debounceDrag(e, isDragging, offset, editorRef)}
		>
			<FormControl display={'flex'} flexDir={'row'} justifyContent={'space-between'}>
				<Flex userSelect={'none'} _hover={{ cursor: 'grab' }}>
					<FormLabel
						_hover={{ cursor: 'grab' }}
						m={0}
						borderColor={'gray.200'}
						fontFamily={'Poppins'}
						color={'gray.700'}
						fontWeight="bold"
					>
						{selectedComponentPropsValue.componentGroup || 'Componente'}
					</FormLabel>
				</Flex>
			</FormControl>

			<FormControl display={'flex'} flexDir={'row'} width={'auto'} mr={3}>
				<Flex userSelect={'none'} gap={2} _hover={{ cursor: 'grab' }} mb={3}>
					<FormLabel
						_hover={{ cursor: 'grab' }}
						m={0}
						borderColor={'gray.200'}
						fontFamily={'Poppins'}
						color={'gray.700'}
						fontWeight="bold"
					>
						Template
					</FormLabel>

					<Select
						w={'80px'}
						bg={'white'}
						borderRadius={'8px'}
						size="sm"
						value={templateId || 1}
						onChange={(e) =>
							setSelectedTemplate(e.target.value, dispatch, componentId, selectedPageValue, componentGroup, xPos, yPos)
						}
					>
						{getTemplateOptions(templates)}
					</Select>
				</Flex>
			</FormControl>
			<Flex gap={3}>
				<MenuResetComponent />
				<DuplicateComponent />
				<IconButton
					key={'icon-button-3'}
					onClick={() =>
						removeElement({ componentId, pages, dispatch, selectedPageValue, selectedComponentPropsValue })
					}
					bg={'white'}
					_hover={r300}
					_active={r400}
					variant="outline"
					size={'sm'}
					aria-label="Deletar componente"
					icon={<UilTrashAlt size={18} />}
				/>
				<PopoverCloseButton position={'relative'} right={0} />
			</Flex>
		</PopoverHeader>
	);
};
const EditorInputsHeader = React.memo(EditorInputsHeaderWM);
export default EditorInputsHeader;
